module.exports = __webpack_public_path__ + "img/usdt.43f688a0.svg";